import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import testimonialsData from '../data/testimonials.json';
import SafeIcon from '../common/SafeIcon';

const Testimonials = () => {
  const { t } = useLanguage();

  return (
    <section id="testimonials" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="text-brand font-bold uppercase tracking-wider text-sm">{t('testimonials.tagline')}</span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mt-2 mb-4">
            {t('testimonials.title')}
          </h2>
          <div className="w-16 h-1 bg-brand mx-auto rounded-full"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonialsData.map((item) => (
            <div key={item.id} className="bg-gray-50 p-8 rounded-2xl shadow-sm relative">
              <SafeIcon name="MessageSquare" className="absolute top-6 right-6 text-4xl text-gray-200" />
              
              <div className="flex gap-1 text-yellow-400 mb-6">
                {[...Array(5)].map((_, i) => (
                  <SafeIcon key={i} name="Star" className={i < item.rating ? "fill-current" : "text-gray-300"} />
                ))}
              </div>
              
              <p className="text-gray-700 italic mb-6 relative z-10 leading-relaxed">
                "{t(`testimonials.items.${item.id}.text`)}"
              </p>
              
              <div className="flex items-center gap-4">
                <div className="w-10 h-10 bg-brand/10 rounded-full flex items-center justify-center text-brand font-bold">
                  {t(`testimonials.items.${item.id}.name`).charAt(0)}
                </div>
                <div>
                  <h4 className="font-bold text-gray-900">{t(`testimonials.items.${item.id}.name`)}</h4>
                  <span className="text-xs text-gray-500 uppercase tracking-wider flex items-center gap-1">
                    <SafeIcon name="CheckCircle" className="text-green-500 w-3 h-3" /> Verified Customer
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Testimonials;